import { makeStyles } from '@material-ui/core';
import byxLogo from './byx-logo.png';

const useStyles = makeStyles({
  img: {
    height: 32,
    width: 'auto',
    display: 'block',
    // O logo é indigo; na sidebar (sempre escura) vira branco, como no
    // design "Backstage byx".
    filter: 'brightness(0) invert(1)',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <img className={classes.img} src={byxLogo} alt="byx" />;
};
